
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M19 0H5C2.24 0 0 2.24 0 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zm3 19c0 1.65-1.35 3-3 3H5c-1.65 0-3-1.35-3-3V5c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v14zM5 10c0-.55.45-1 1-1h9c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1zm0-4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1zm14 8c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1zm-9 4c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1z"}})])
          )
        }
      }
    